import { TimeSettingsContextlessPoliciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useTimeSettingsContextlessPolicies = () => {
  const { data, loading } = useQuery(TimeSettingsContextlessPoliciesDocument)
  const policies = data?.timeSettings?._policies

  return {
    loading,
    manageTimeRangeCategories: !!policies?.manageTimeRangeCategories.can,
    manageBreakConfigurations: !!policies?.manageBreakConfigurations.can,
  }
}
